import axios from 'axios';
import { message } from 'antd';
import { getToken, clearUserData, setLastRequestTime } from './auth';

// 根据环境设置 baseURL
// 开发环境：使用代理
// 生产环境：使用空字符串，让浏览器使用当前域名
const baseURL = process.env.NODE_ENV === 'production' 
  ? '' 
  : '';

const request = axios.create({
  baseURL: baseURL,
  timeout: 60000, // 60秒超时（文件上传需要更长时间）
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = getToken();
    console.log('📤 发送请求:', config.method?.toUpperCase(), config.url);
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // 每次发送请求时更新最后请求时间
      setLastRequestTime();
      console.log('  ✅ 已添加Authorization头');
      console.log('  ✅ 已更新lastRequestTime');
    } else {
      console.log('  ⚠️ 无token，未添加Authorization头');
    }
    
    // 如果是 FormData，让 axios 自动设置 Content-Type（包含 boundary）
    if (config.data instanceof FormData) {
      // 不设置 Content-Type，让浏览器自动设置
      delete config.headers['Content-Type'];
      console.log('  ℹ️ FormData请求，已删除Content-Type');
    }
    
    return config;
  },
  (error) => {
    console.error('❌ 请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    console.log('📥 收到响应:', response.config.url, '状态码:', res.code);
    
    // 检查业务状态码
    // 如果后端返回的 code 不是 200，则认为是业务错误
    if (res.code && res.code !== 200) {
      console.log('  ⚠️ 业务错误，code:', res.code, 'msg:', res.msg);
      
      // 检查是否是身份过期（可能是 401 或其他特定错误码）
      if (res.code === 401 || res.code === 403) {
        console.log('  ❌ 身份认证失败，清除数据并跳转登录');
        message.error(res.msg || '登录已过期，请重新登录');
        clearUserData();
        // 延迟跳转，确保用户看到提示
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
        return Promise.reject(new Error(res.msg || '登录已过期'));
      }
      
      // 其他业务错误，不自动显示错误信息，让调用方处理
      return Promise.reject(new Error(res.msg || res.message || '请求失败'));
    }
    
    console.log('  ✅ 请求成功');
    return res;
  },
  (error) => {
    console.error('❌ 响应错误:', error.config?.url, error.message);
    
    // HTTP 状态码错误
    if (error.response) {
      const status = error.response.status;
      const data = error.response.data;
      console.log('  HTTP状态码:', status, '响应数据:', data);
      
      switch (status) {
        case 401:
          // 身份认证失败或已过期
          console.log('  ❌ 401错误，清除数据并跳转登录');
          message.error('登录已过期，请重新登录');
          clearUserData();
          // 延迟跳转，确保用户看到提示
          setTimeout(() => {
            window.location.href = '/login';
          }, 1000);
          break;
        case 403:
          message.error('没有权限访问该资源');
          break;
        case 404:
          message.error('请求错误，未找到该资源');
          break;
        case 500:
          message.error(data?.msg || data?.message || '服务器错误');
          break;
        default:
          message.error(data?.msg || data?.message || '请求失败');
      }
    } else if (error.message) {
      // 这是业务错误，不在这里显示
      // message.error(error.message);
    } else {
      message.error('网络错误，请检查您的网络连接');
    }
    return Promise.reject(error);
  }
);

export default request;


